import axios from "axios";

const ADDSERVICE_API_BASE_URL = "https://doclicapp.herokuapp.com/analyse/add";
const GETSERVICEID_API_BASE_URL =
  "https://doclicapp.herokuapp.com/analyse/services";
const UPDAITESERVICE_API_BASE_URL =
  "https://doclicapp.herokuapp.com/analyse/update";
const DELETESERVISE_API_BASE_URL =
  "https://doclicapp.herokuapp.com/analyse/delete";

class ServiceProfile {
  getServiceId(id) {
    return axios.get(GETSERVICEID_API_BASE_URL + "/" + id);
  }
  addService(services, laboratory) {
    return axios.post(ADDSERVICE_API_BASE_URL, {
      services,
      laboratory,
    });
  }

  updateService(id, designation, price, type) {
    return axios.put(UPDAITESERVICE_API_BASE_URL, {
      id,
      designation,
      price,
      type,
    });
  }
  deleteServise(id) {
    return axios.delete(DELETESERVISE_API_BASE_URL + "/" + id);
  }
}

export default new ServiceProfile();
